import _ from 'lodash';
import { apiSearch, apiFetch, apiRemove } from '../utility';

export const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			base : 'carrier',
			dispatch,
			callback,
		});
	};
};

export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'carrier.get',
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'carrier.add',
			listNameToUpdate : 'carrierIds',
			params,
			dispatch,
			successMessage : `Carrier created successfully. 
				Click continue to return to the carrier page.`,
			onSuccessRedirectTo : '/logistics/carriers',
			callback,
		});
	};
};

export const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'carrier.update',
			params,
			dispatch,
			successMessage : `Carrier updated successfully. 
				Click continue to return to the carrier page.`,
			onSuccessRedirectTo : '/logistics/carriers',
			callback,
		});
	};
};

export const remove = ({carrierId, callback = _.noop}) => {
	return dispatch => {
		apiRemove({
			base : 'carrier',
			id : carrierId,
			dispatch,
			callback,
		});
	};
};
